(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime/helpers/toConsumableArray", "@babel/runtime/helpers/defineProperty", "./index.less", "../popup", "../button", "@better-scroll/core", "../_util/wheel.esm", "../_mixins/picker", "../_mixins/basicPicker", "../_mixins/dialogBounce", "../_mixins/osProps"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime/helpers/toConsumableArray"), require("@babel/runtime/helpers/defineProperty"), require("./index.less"), require("../popup"), require("../button"), require("@better-scroll/core"), require("../_util/wheel.esm"), require("../_mixins/picker"), require("../_mixins/basicPicker"), require("../_mixins/dialogBounce"), require("../_mixins/osProps"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.toConsumableArray, global.defineProperty, global.index, global.popup, global.button, global.core, global.wheel, global.picker, global.basicPicker, global.dialogBounce, global.osProps);
    global.unknown = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _toConsumableArray2, _defineProperty2, _index, _popup, _button, _core, _wheel, _picker, _basicPicker, _dialogBounce, _osProps) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _toConsumableArray2 = _interopRequireDefault(_toConsumableArray2);
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _popup = _interopRequireDefault(_popup);
  _button = _interopRequireDefault(_button);
  _core = _interopRequireDefault(_core);
  _wheel = _interopRequireDefault(_wheel);
  _picker = _interopRequireDefault(_picker);
  _basicPicker = _interopRequireDefault(_basicPicker);
  _dialogBounce = _interopRequireDefault(_dialogBounce);
  _osProps = _interopRequireDefault(_osProps);

  var _components;

  _core.default.use(_wheel.default);

  var _default = {
    render: function render() {
      var _vm = this;

      var _h = _vm.$createElement;

      var _c = _vm._self._c || _h;

      return _c('div', {
        ref: "nxpicker",
        class: {
          'nx-picker': true,
          'nx-os-blur-material': _vm.blurMaterial
        }
      }, [_c('nx-popup', {
        ref: "bounceDialog",
        attrs: {
          "value": _vm.value || _vm.isVisible,
          "hasMask": _vm.hasMask,
          "lockScroll": _vm.lockScroll,
          "maskClosable": _vm.maskClosable,
          "position": _vm.position,
          "transition": _vm.popupTransition || _vm.transition,
          "ariaAutoFocus": _vm.ariaAutoFocus,
          "slideDownDisappear": _vm.slideDownDisappear,
          "backClosePopup": _vm.backClosePopup,
          "backClosePopupCustomEvent": _vm.backClosePopupCustomEvent,
          "is-webview-full": _vm.isWebviewFull
        },
        on: {
          "input": _vm.$_onInput,
          "show": _vm.$_onShow,
          "hide": _vm.$_onHide
        }
      }, [_c('div', {
        staticClass: "nx-picker-content",
        on: {
          "touchmove": function touchmove($event) {
            $event.preventDefault();
          }
        }
      }, [_vm._t("header"), _c('div', {
        staticClass: "nx-picker-body",
        on: {
          "click": function click($event) {
            $event.stopPropagation();
          }
        }
      }, [_c('div', {
        staticClass: "nx-picker-header"
      }, [_vm.title ? _c('div', {
        staticClass: "nx-picker-title",
        attrs: {
          "aria-label": _vm.title,
          "nx-popup-aria-auto-focus": "true"
        },
        on: {
          "touchstart": _vm.handleTouchstart,
          "touchmove": _vm.handleTouchmove,
          "touchend": function touchend($event) {
            return _vm.handleTouchend(_vm.$_onHide);
          }
        }
      }, [_vm._v("\n            " + _vm._s(_vm.title) + "\n          ")]) : _vm._e(), _vm.describe ? _c('div', {
        staticClass: "nx-picker-describe"
      }, [_vm._v(_vm._s(_vm.describe))]) : _vm._e()]), _c('div', {
        ref: "pickerWrapper",
        staticClass: "nx-picker-wrapper",
        attrs: {
          "nx-popup-aria-auto-focus": "true"
        }
      }, [_vm._l(_vm.pickerData, function (data, index) {
        return _c('div', {
          key: index,
          staticClass: "column",
          class: "column" + index,
          attrs: {
            "tabindex": "-1",
            "aria-label": _vm.ariaSaySelected && data[_vm.ariaPickerList[index]] ? data[_vm.ariaPickerList[index]].unit ? (data[_vm.ariaPickerList[index]].ariaLabelContent || data[_vm.ariaPickerList[index]].text) + data[_vm.ariaPickerList[index]].unit + '-滑动滚轮控件-可上下滚动切换' : (data[_vm.ariaPickerList[index]].ariaLabelContent || data[_vm.ariaPickerList[index]].text) + '-滑动滚轮控件-可上下滚动切换' : ''
          }
        }, [_c('div', {
          staticClass: "nx-picker-scroll"
        }, [_vm.$scopedSlots.default ? [_vm._t("default", null, {
          "pickerData": data
        })] : _vm._l(data, function (item) {
          return _c('div', {
            key: item.value,
            staticClass: "picker-item",
            attrs: {
              "aria-hidden": "true"
            },
            domProps: {
              "innerHTML": _vm._s(item.text)
            }
          });
        })], 2)]);
      }), _c('i', {
        staticClass: "border-top-1px"
      }), _c('i', {
        staticClass: "border-bottom-1px"
      })], 2)]), _c('div', {
        staticClass: "nx-picker-actions"
      }, [_c('nx-button', {
        staticClass: "nx-picker-btn",
        attrs: {
          "type": "frame-plus"
        },
        on: {
          "click": _vm._confirm
        }
      }, [_vm._v("\n          " + _vm._s(_vm.okText) + "\n        ")]), _c('nx-button', {
        staticClass: "nx-picker-btn",
        attrs: {
          "type": "link"
        },
        on: {
          "click": _vm._cancel
        }
      }, [_vm._v(_vm._s(_vm.cancelText))])], 1)], 2)]), _c('div', {
        staticClass: "nx-picker-scroll-aria",
        attrs: {
          "aria-live": "polite"
        }
      }, [_vm._v("\n    " + _vm._s(_vm.ariaPickerContent) + "\n  ")])], 1);
    },
    name: 'nx-picker',
    mixins: [_picker.default, _basicPicker.default, _dialogBounce.default, _osProps.default],
    components: (_components = {}, (0, _defineProperty2.default)(_components, _popup.default.name, _popup.default), (0, _defineProperty2.default)(_components, _button.default.name, _button.default), _components),
    props: {
      useTransition: {
        type: Boolean,
        default: false
      }
    },
    data: function data() {
      return {
        isVisible: false,
        pickerData: this.data.slice(),
        ariaPickerList: [],
        //标记 第几列的第几项是active的
        ariaPickerScroll: false,
        popupTransition: undefined,
        ariaAutoFocus: true
      };
    },
    computed: {
      ariaPickerContent: function ariaPickerContent() {
        var _this = this;

        if (!this.isVisible || !this.ariaPickerScroll) return '';
        var res = '';
        this.ariaPickerList.forEach(function (item, index) {
          var _pickerItem = _this.pickerData[index][item];

          if (_pickerItem) {
            if (_pickerItem.unit) {
              res = res + (_pickerItem.ariaLabelContent || _pickerItem.text) + _pickerItem.unit + ' ';
            } else {
              res = res + (_pickerItem.ariaLabelContent || _pickerItem.text) + ' ';
            }
          }
        });
        return res;
      },
      ariaSaySelected: function ariaSaySelected() {
        return this.pickerData.length && this.ariaPickerList.length && this.pickerData[0].length;
      }
    },
    created: function created() {
      this._values = [];
      this._indexes = this.selectedIndex; // 无障碍-选中项配置

      if (!this.selectedIndex || !Array.isArray(this.selectedIndex) || this.selectedIndex.length === 0) {
        // 默认选中项不传的时候
        this.ariaPickerList = (0, _toConsumableArray2.default)(Array(this.pickerData.length)).map(function () {
          return 0;
        });
      } else {
        this.ariaPickerList = this.selectedIndex;
      }
    },
    mounted: function mounted() {
      this._initPicker();
    },
    watch: {
      value: function value(val) {
        this.isVisible = val;

        if (!val) {
          this.ariaPickerScroll = false;
        }
      },
      selectedIndex: function selectedIndex(_new) {
        // 无障碍-选中项配置
        if (!_new || !Array.isArray(_new) || _new.length === 0) {
          // 默认选中项不传的时候
          this.ariaPickerList = (0, _toConsumableArray2.default)(Array(this.pickerData.length)).map(function () {
            return 0;
          });
        } else {
          this.ariaPickerList = _new;
        }
      }
    },
    methods: {
      refillColumn: function refillColumn(index, data) {
        var _this2 = this;

        var pickerWrapper = this.$refs.pickerWrapper;
        var scroll = pickerWrapper.children[index].querySelector('.nx-picker-scroll');
        var picker = this.pickers ? this.pickers[index] : false;
        var dist = 0;

        if (scroll && picker) {
          var oldData = this.pickerData[index];
          this.$set(this.pickerData, index, data);
          var selectedIndex = picker.getSelectedIndex();

          if (oldData.length) {
            var oldValue = oldData[selectedIndex] && oldData[selectedIndex].value;

            for (var i = 0; i < data.length; i++) {
              if (data[i] && data[i].value === oldValue) {
                dist = i;
                break;
              }
            }
          }

          this._indexes[index] = dist;
          this.$nextTick(function () {
            // recreate wheel so that the wrapperHeight will be correct.
            picker = _this2._createPicker(pickerWrapper, index);
            picker.wheelTo(dist);
          });
        }

        return dist;
      },
      _initPicker: function _initPicker() {
        var _this3 = this;

        var picker = this.$refs.nxpicker; // picker初始隐藏时，先在后台初始化

        if (!this.value) {
          picker.classList.add('nx-picker_hidden'); // 无界面

          this.popupTransition = 'no-transition'; // 无动画

          this.ariaAutoFocus = false; // 无聚焦
        }

        this.isVisible = true;
        this.$nextTick(function () {
          _this3.pickers = [];
          var pickerWrapper = _this3.$refs.pickerWrapper;

          for (var i = 0; i < _this3.pickerData.length; i++) {
            _this3._createPicker(pickerWrapper, i);
          }

          _this3.isVisible = false;
          setTimeout(function () {
            _this3.popupTransition = undefined;
            _this3.ariaAutoFocus = true;
            picker.classList.remove('nx-picker_hidden');
          }, 300);
          _this3.dirty && _this3._destroyExtraPickers();
          _this3.dirty = false;
        });
      },
      $_onShow: function $_onShow() {
        if (this.pickers && !this.dirty) {
          for (var i = 0; i < this.pickers.length; i++) {
            this.pickers[i].enable();
            this.pickers[i].refresh();
            this.pickers[i].wheelTo(this._indexes[i]);
          }
        }

        this.$emit('show');
      },
      _createPicker: function _createPicker(pickerWrapper, i) {
        var _this4 = this;

        if (!this.pickers[i]) {
          var _pickerWrapper$childr, _pickerWrapper$childr2, _pickerWrapper$childr3;

          var picker = this.pickers[i] = new _core.default(pickerWrapper.children[i], {
            autoBlur: false,
            // flickLimitTime: 2,
            flickLimitDistance: 5,
            deceleration: ((_pickerWrapper$childr = pickerWrapper.children[i]) === null || _pickerWrapper$childr === void 0 ? void 0 : (_pickerWrapper$childr2 = _pickerWrapper$childr.children[0]) === null || _pickerWrapper$childr2 === void 0 ? void 0 : (_pickerWrapper$childr3 = _pickerWrapper$childr2.children) === null || _pickerWrapper$childr3 === void 0 ? void 0 : _pickerWrapper$childr3.length) > 6 ? 0.0025 : 0.008,
            // momentumLimitDistance: 1,
            useTransition: this.useTransition,
            bindToWrapper: !!this.isWebviewFull,
            swipeTime: 1500,
            wheel: {
              blurMaterial: this.blurMaterial,
              selectedIndex: this._indexes[i] || 0,
              wheelWrapperClass: 'nx-picker-scroll',
              wheelItemClass: 'picker-item'
            },
            zoom: true,
            probeType: 3
          });
          picker.on('scrollEnd', function () {
            _this4.$set(_this4.ariaPickerList, i, _this4.pickers[i].getSelectedIndex());

            _this4.ariaPickerScroll = true;

            _this4.$emit('change', i, _this4.pickers[i].getSelectedIndex());
          });
        } else {
          this.pickers[i].refresh();
        }

        return this.pickers[i];
      },
      _confirm: function _confirm() {
        if (!this._canConfirm()) {
          return;
        }

        this.hide();
        var changed = false;
        var pickerSelectedText = [];
        var length = this.pickerData.length;
        var oldLength = this._values.length; // when column count has changed.

        if (oldLength !== length) {
          changed = true;
          oldLength > length && (this._values.length = this._indexes.length = length);
        }

        for (var i = 0; i < length; i++) {
          var index = this.pickers[i].getSelectedIndex();
          this._indexes[i] = index;
          var value = null;
          var text = '';

          if (this.pickerData[i].length) {
            value = this.pickerData[i][index].value;
            text = this.pickerData[i][index].text;
          }

          if (this._values[i] !== value) {
            changed = true;
          }

          this._values[i] = value;
          pickerSelectedText[i] = text;
        }

        this.$emit('confirm', this._values, this._indexes, pickerSelectedText);

        if (changed) {
          this.$emit('value-change', this._values, this._indexes, pickerSelectedText);
        }
      },
      _cancel: function _cancel() {
        this.hide();
        this.$emit('cancel');
      },
      _canConfirm: function _canConfirm() {
        return this.pickers.every(function (picker) {
          return !picker.pending;
        });
      },
      $_onInput: function $_onInput(val) {
        this.$emit('input', val);
      },
      $_onHide: function $_onHide() {
        this.hide();
        this.$emit('hide');
      },
      hide: function hide() {
        if (!this.value) {
          return;
        }

        this.$emit('input', false);

        for (var i = 0; i < this.pickers.length; i++) {
          this.pickers[i].disable();
        }
      },
      _destroyExtraPickers: function _destroyExtraPickers() {
        var dataLength = this.pickerData.length;

        if (this.pickers.length > dataLength) {
          var extraPickers = this.pickers.splice(dataLength);
          extraPickers.forEach(function (picker) {
            picker.destroy();
          });
        }
      },
      unitShow: function unitShow(data) {
        var _data$;

        return data === null || data === void 0 ? void 0 : (_data$ = data[0]) === null || _data$ === void 0 ? void 0 : _data$.unit;
      },
      unitShowBtn: function unitShowBtn(arr) {
        if (arr.length <= 1) {
          return true;
        }

        var firstUnit = arr[0].unit;

        for (var i = 1; i < arr.length; i++) {
          if (arr[i].unit !== firstUnit) {
            return false;
          }
        }

        return true;
      },
      unitLeft: function unitLeft(data) {
        var _data$2, _data$2$text;

        var left = (data === null || data === void 0 ? void 0 : (_data$2 = data[0]) === null || _data$2 === void 0 ? void 0 : (_data$2$text = _data$2.text) === null || _data$2$text === void 0 ? void 0 : _data$2$text.length) === 4 ? '4.8em' : '3em';
        return {
          left: left
        };
      }
    },
    beforeDestroy: function beforeDestroy() {
      this.pickers && this.pickers.forEach(function (picker) {
        picker.destroy();
      });
      this.pickers = null;
    }
  };
  _exports.default = _default;
});